import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { getScreenIsReady } from 'selectors/screen'
import { getUserID, isSessionSet } from 'selectors/user/session'
import { getIsUsersArtworksAccount } from '../selectors/app'

const mapStateToProps = createStructuredSelector({
  isReady: getScreenIsReady,
  isSet: isSessionSet,
  isUsersArtworksAccount: getIsUsersArtworksAccount,
  userID: getUserID,
})

export type ConnectorProps = {
  isReady: boolean
  isSet: boolean
  isUsersArtworksAccount: boolean
  userID: number
}
export default connect(mapStateToProps)
